import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "main-container content-start mt-8" }
const _hoisted_2 = { class: "action-header col-start-1 col-end-13 flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "mb-0 ac-large-title" }, "Temas Başlıkları", -1)
const _hoisted_4 = {
  key: 1,
  class: "alt-table col-start-1 col-end-13 w-full"
}
const _hoisted_5 = { class: "category-header" }
const _hoisted_6 = {
  colspan: "3",
  class: "font-bold bg-[var(--box-color)] border-b-2"
}
const _hoisted_7 = { class: "w-6" }
const _hoisted_8 = { class: "material-icons" }
const _hoisted_9 = { class: "flex items-center justify-end gap-8" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

import type { AcMilestone } from '@/types/crm';
import { useGetDocs, postData, updateData, deleteData } from '../../mixins/modularFirebaseOperations';
import { ref, computed } from 'vue';
import { modalClosed } from '../../mixins/visualFormatters';
import addMilestoneTypeForm from '../crm-components/addMilestoneTypeForm.vue';
import acMediumModal from '../reusable/teleports/acMediumModal.vue';
import skeletonTable from '../reusable/skeletonTable.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'MileStones',
  setup(__props) {

const { docs, isLoadingDocs } =  useGetDocs<AcMilestone>("crm/milestones/list")
const isLoadingMileStones = ref(false)

const isAddingMilestone = ref(false)
const editedMilestone = ref<AcMilestone | undefined>(undefined)
const milestoneCategories = computed(() => [...new Set(docs.value.map(doc => doc.category))])

const groupedMilestones = computed(() => {
    const groups: Record<string, AcMilestone[]> = {}
    docs.value.forEach(milestone => {
        if (!groups[milestone.category]) {
            groups[milestone.category] = []
        }
        groups[milestone.category].push(milestone)
    })
    return groups
})

const handleMilestoneTypeAdded = async (milestoneType: AcMilestone) => {
    try {
        const docRef = await postData(milestoneType, "crm/milestones/list")
        docs.value.push({
            id: docRef?.id ?? "",
            ...milestoneType,
        })
    } catch (error) {
        console.error(error)
    }
    finally {
        isAddingMilestone.value = false
        modalClosed()
    }
}

const handleMilestoneTypeUpdated = async (milestoneType: AcMilestone) => {
    try {
        await updateData("crm/milestones/list", milestoneType!.id!, milestoneType)
        const index = docs.value.findIndex(doc => doc.id === milestoneType.id)
        docs.value[index] = milestoneType
    } catch (error) {
        console.error(error)
    }
    finally {
        editedMilestone.value = undefined
        modalClosed()
    }
}

const handleMilestoneTypeDeleted = async (milestoneType: AcMilestone) => {
    try {
        await deleteData("crm/milestones/list", milestoneType!.id!)
        const index = docs.value.findIndex(doc => doc.id === milestoneType.id)
        docs.value.splice(index, 1)
    } catch (error) {
        console.error(error)

    }
}

const handleClosed = () => {
    isAddingMilestone.value = false
    editedMilestone.value = undefined
    modalClosed()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "ac-add-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isAddingMilestone.value = true))
      }, "Temas Türü Ekle")
    ]),
    (_unref(isLoadingDocs) || isLoadingMileStones.value)
      ? (_openBlock(), _createBlock(skeletonTable, {
          key: 0,
          width: 100,
          class: "col-start-1 col-end-13",
          rows: 15
        }))
      : (_openBlock(), _createElementBlock("table", _hoisted_4, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupedMilestones.value, (milestones, category) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: category }, [
                _createElementVNode("tr", _hoisted_5, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(category), 1)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(milestones, (milestone) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "vertical-center",
                    key: milestone.id
                  }, [
                    _createElementVNode("td", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(milestone.icon), 1)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(milestone.title), 1),
                    _createElementVNode("td", _hoisted_9, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (editedMilestone.value = milestone),
                        class: "ac-table-button"
                      }, " Düzenle ", 8, _hoisted_10),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (handleMilestoneTypeDeleted(milestone)),
                        class: "ac-table-button text-red-400 hover:text-red-500"
                      }, " Sil ", 8, _hoisted_11)
                    ])
                  ]))
                }), 128))
              ], 64))
            }), 128))
          ])
        ])),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        appear: "",
        type: "animation",
        "enter-active-class": "animate__animated animate__fadeIn animate__fast",
        "leave-active-class": "animate__animated animate__fadeOut animate__faster"
      }, {
        default: _withCtx(() => [
          (isAddingMilestone.value || editedMilestone.value)
            ? (_openBlock(), _createBlock(acMediumModal, {
                key: 0,
                onModalClosed: handleClosed,
                class: "lg:!top-44 overflow-y-scroll",
                title: "Yeni Temas Kategorisi Ekle",
                width: "50vw",
                height: "fit-content"
              }, {
                default: _withCtx(() => [
                  _createVNode(addMilestoneTypeForm, {
                    onMilestoneTypeAdded: handleMilestoneTypeAdded,
                    onMilestoneTypeUpdated: handleMilestoneTypeUpdated,
                    onCancelled: _cache[1] || (_cache[1] = ($event: any) => {isAddingMilestone.value = false; editedMilestone.value = undefined; _unref(modalClosed)()}),
                    "existing-milestone-type": editedMilestone.value,
                    "existing-milestone-categories": milestoneCategories.value
                  }, null, 8, ["existing-milestone-type", "existing-milestone-categories"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ]))
}
}

})